// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__aBQdN","titleDropdown":"style_title-dropdown__gVmJ3","table":"style_table__mf5oK"};